<template>
  <div
    v-if="item.locked && item.lockedBy"
    class="lock-indicator"
    :style="indicatorStyles"
  >
    {{ item.lockedBy.userName }}
  </div>
</template>

<script>
export default {
  name: "LockIndicator",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    indicatorStyles() {
      if (this.item.locked && this.item.lockedBy) {
        return {
          backgroundColor: this.item.lockedBy.userColor,
        };
      }
      return {};
    },
  },
};
</script>

<style scoped>
.lock-indicator {
  color: white;
  margin-top: var(--spacing-1);
  display: inline;
  padding: 2px 6px;
  border-radius: var(--rounded);
  font-size: var(--font-size-tiny);
  pointer-events: none;
  float: right;
}
</style>
